export function getFullStoryText(chapters: StoryChapter[]): string {
  return [...chapters]
    .sort((a, b) => a.position - b.position)
    .map((chapter) => chapter.content)
    .join('\n\n')
}
